import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Cómo recibo el Kit después de comprar?',
    a: 'Inmediatamente después de confirmar el pago recibís un mail en tu casilla con el enlace de descarga de todos los PDFs. Acceso en menos de 5 minutos.'
  }, {
    q: '¿Sirve para profesionales con poca experiencia o solo para las avanzadas?',
    a: 'Sirve para ambas. El sistema está diseñado para profesionales que quieren dejar de improvisar, sin importar los años de experiencia. Si ya tenés experiencia, vas a ordenar y potenciar lo que ya hacés. Si estás empezando, vas a arrancar con un sistema probado desde el día uno.'
  }, {
    q: '¿Es editable? ¿Puedo modificarlo?',
    a: 'Los PDFs no son editables para proteger el contenido. Pero podés imprimir, usar en pantalla y aplicar cada herramienta directamente en tu consulta.'
  }, {
    q: '¿Los 6 bonos están en las dos ofertas?',
    a: 'Sí. Los 6 bonos están incluidos en las dos opciones sin costo extra.'
  }, {
    q: '¿Sirve si trabajo de forma individual o solo para grupos y talleres?',
    a: 'Sirve para ambas modalidades. Todas las herramientas tienen adaptaciones para consulta individual, grupal y talleres de postparto.'
  }, {
    q: '¿Sirve si tengo pacientes en distintas etapas del postparto?',
    a: 'Sí. El kit cubre postparto inmediato, tardío, situaciones de crisis y DPP. Cada herramienta especifica para qué etapa y perfil está pensada.'
  }, {
    q: '¿Qué diferencia tiene con otros materiales de postparto del mercado?',
    a: 'Es el único sistema en Argentina que integra evaluación, guiones, protocolos de crisis, DPP, gestión de práctica y comunicación en un solo kit listo para usar. No es teoría. Es herramienta lista para tu próxima sesión.'
  }, {
    q: '¿Por qué elegir el Pack Plus y no el estándar?',
    a: 'Si solo querés las herramientas clínicas, el estándar es suficiente. Si además querés organizar tu práctica privada y tener presencia digital para conseguir más pacientes, el Pack Plus es la opción completa.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días de garantía total. Si no es lo que esperabas, te devolvemos el 100% del dinero. Sin preguntas. Sin formularios.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-12 md:py-24 px-4 sm:px-6 lg:px-8 bg-cream" data-id="element-38">
      <div className="max-w-3xl mx-auto" data-id="element-39">
        <div className="text-center mb-8 md:mb-16" data-id="element-40">
          <h2 className="text-3xl md:text-5xl font-bold text-navy font-serif" data-id="element-41">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-3 md:space-y-4" data-id="element-42">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="bg-white rounded-xl md:rounded-2xl border border-navy/10 overflow-hidden shadow-sm hover:border-navy/20 transition-colors" data-id="element-43">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full text-left px-4 py-4 md:px-6 md:py-5 flex items-center justify-between gap-3 md:gap-4 focus:outline-none" data-id="element-44">
                <span className="font-bold text-navy pr-2 md:pr-4 text-sm md:text-base" data-id="element-45">
                  {faq.q}
                </span>
                <ChevronDown className={`w-4 h-4 md:w-5 md:h-5 text-navy/40 flex-shrink-0 transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-46" />
              </button>

              <AnimatePresence data-id="element-47">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-48">
                    <div className="px-4 pb-4 md:px-6 md:pb-5 text-navy/70 leading-relaxed text-sm md:text-base" data-id="element-49">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}